import { Loader, Stack } from "@octopus-energy/coral/atoms"
import { Page } from "../Page"

export function PageLoader() {
    return (
        <Page maxWidthPreset="md">
            <Stack justifyContent="center">
                <Loader />
            </Stack>
        </Page>
    )
}
